// Öffentliche Knotenseiten (/knots/<slug>): der Server liefert Übersicht aller Schritte mit Bild und Satz; hier
// ersetzt der Spieler (Schritte, Animation, Übersicht) sie an Ort und Stelle. Daten kommen als JSON aus der Seite,
// Texte über window.tr (Gruppe `knot` in der Hülle). Schlägt etwas fehl, bleibt die Übersicht stehen.
// Stil kommt als eigener Einstieg (knots-css), damit die Übersicht ihn ohne dieses Skript bekommt.
import { mountPlayer, knotTexts } from '../shared/knots/player.js';

function start() {
  const host = document.querySelector('[data-kn-player]');
  const raw = document.getElementById('kn-data');
  if (!host || !raw) return null;
  try {
    const knot = JSON.parse(raw.textContent);
    const tr = (k, v) => (window.tr ? window.tr(k, v) : k);
    return mountPlayer(host, { knot, texts: knotTexts(tr, knot.slug) });
  } catch (e) {
    console.warn('Knoten-Spieler nicht gestartet', e);
    return null;
  }
}

if (typeof document !== 'undefined') {
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start, { once: true });
  else start();
}
